{
  "appTitle": "BACK OFFICE",
  "changelog": {
    "title": "Changelog",
    "description": "What's new in Back Office"
  },
  "errors": {
    "loadFailed": "Failed to load details."
  },
  "accessDenied": {
    "title": "Access denied",
    "description": "You do not have permission to view this page.",
    "missingPermission": "Missing permission: {{permission}}",
    "backToHome": "Go back"
  },
  "noAccess": {
    "title": "No access",
    "description": "Your account does not have permission to use the backoffice.",
    "hint": "Contact your administrator to request access.",
    "signedInAs": "Signed in as {{email}}",
    "signOut": "Sign out"
  },
  "nav": {
    "management": "Management",
    "iam": "Identity and Access",
    "ingress": "Data Ingress",
    "octo": "Octo",
    "hardware": "Hardware"
  },
  "home": {
    "title": "Home"
  },
  "users": {
    "tools": {
      "menuLabel": "Tools",
      "lastLogin": "Last login distribution"
    },
    "lastLoginChart": {
      "title": "Last login distribution",
      "description": "When users matching the current filter last signed in.",
      "empty": "No login activity for the current selection.",
      "neverNote": "Never logged in: {{count}}",
      "tooltipTotal": "Total"
    },
    "title": "Users",
    "list": {
      "columns": {
        "id": "ID",
        "publicId": "Public ID",
        "userName": "Username",
        "email": "Email",
        "fullName": "Full Name",
        "realm": "Realm",
        "defaultStore": "Default Store",
        "mfa": "MFA",
        "lastLoginAt": "Last Login",
        "lastAttemptAt": "Last Attempt",
        "status": "Status",
        "createdAt": "Created"
      },
      "actions": {
        "activate": "Activate",
        "deactivate": "Deactivate",
        "changeStore": "Change Store",
        "delete": "Delete User",
        "cannotModifySelf": "You can't deactivate or delete your own account"
      },
      "addUserButton": "Create User",
      "searchPlaceholder": "Search users...",
      "filter": {
        "realm": "Realm",
        "searchRealms": "Search realms…",
        "noRealms": "No realms found",
        "chain": "Chain",
        "searchChains": "Search chains…",
        "noChains": "No chains found",
        "store": "Store",
        "searchStores": "Search stores…",
        "noStores": "No stores found"
      }
    },
    "dialog": {
      "createTitle": "Create User",
      "deactivateTitle": "Deactivate User",
      "activateTitle": "Activate User",
      "deactivatePrompt": "Are you sure you want to deactivate",
      "activatePrompt": "Are you sure you want to activate",
      "deactivateWarning": "This user will immediately lose access to focalOS.",
      "deactivateConfirm": "Deactivate",
      "activateConfirm": "Activate"
    },
    "deleteDialog": {
      "title": "Delete User",
      "prompt": "Are you sure you want to permanently delete",
      "warning": "This action cannot be undone.",
      "confirm": "Delete"
    },
    "changeStoreDialog": {
      "title": "Change Default Store",
      "description": "Select a new default store for",
      "storeLabel": "Default Store",
      "selectStore": "Select store",
      "searchStores": "Search stores…",
      "noStores": "No stores found",
      "removePrevious": "Remove previous default from available stores",
      "save": "Save"
    },
    "form": {
      "email": "Email",
      "username": "Username",
      "fullName": "Full Name",
      "realm": "Realm",
      "selectRealm": "Select realm",
      "searchRealms": "Search realms…",
      "noRealms": "No realms found",
      "realmChangeWarning": "Changing SSO realm will remove the user's password from the database; restoring the original password will be impossible.",
      "notRequired": "Not required",
      "password": "Password",
      "passwordEditPlaceholder": "Leave empty to keep current",
      "validationDisabled": "Validation disabled",
      "validationDisabledHint": "Admin group members can set passwords without meeting complexity requirements",
      "groups": "Groups",
      "selectGroups": "Select groups",
      "searchGroups": "Search groups…",
      "noGroups": "No groups found",
      "defaultStore": "Default Store",
      "selectStore": "Select store",
      "searchStores": "Search stores…",
      "noStores": "No stores found",
      "availableStores": "Available Stores",
      "selectAvailableStores": "Select stores",
      "validation": {
        "required": "Required",
        "invalidEmail": "Must be a valid email",
        "passwordMinLength": "Password must be at least 8 characters",
        "emailExists": "A user with this email already exists",
        "usernameExists": "A user with this username already exists"
      },
      "ftFueTraining": "FT FUE Training",
      "requirePasswordReset": "Require password reset",
      "flags": "Flags",
      "selectFlags": "Select flags",
      "searchFlags": "Search flags…",
      "noFlags": "No flags found",
      "supervisor": "Supervisor",
      "selectSupervisor": "Select supervisor",
      "searchSupervisor": "Search people…",
      "noSupervisor": "No people found"
    },
    "detail": {
      "profileTitle": "Profile",
      "fullName": "Full Name",
      "groupsTitle": "Groups",
      "permissionsTitle": "Permissions",
      "directlyAssigned": "Directly assigned",
      "availableStores": "Available Stores"
    },
    "notifications": {
      "activated": "User \"{{name}}\" activated",
      "deactivated": "User \"{{name}}\" deactivated",
      "created": "User \"{{name}}\" created",
      "updated": "User \"{{name}}\" updated",
      "deleted": "User \"{{name}}\" deleted",
      "createFailed": "Failed to create user"
    },
    "permissions": {
      "view": "View",
      "edit": "Edit",
      "fullAccess": "Full access",
      "everyBackofficePermission": "Every backoffice permission",
      "everyPermission": "Every permission (superuser)",
      "allPermissions": "All {{section}} permissions",
      "grantedVia": "Granted via {{permission}}",
      "inheritedFromGroup": "Inherited from group \"{{group}}\"",
      "inheritBanner": {
        "prefix": "This user inherits permissions from",
        "suffix": "Inherited permissions are shown locked and can't be changed here."
      },
      "labels": {
        "approvals": "Approvals",
        "chains": "Chains",
        "regions": "Regions",
        "settings": "Settings",
        "activity": "Activity",
        "stores": "Stores",
        "operations": "Operations",
        "health": "Health",
        "hardware": "Hardware",
        "schedule": "Schedule",
        "cutOffTimes": "Cut-off times",
        "map": "Map",
        "chainValues": "Chain values",
        "storeValues": "Store values",
        "iam": "IAM",
        "users": "Users",
        "groups": "Groups",
        "vendors": "Vendors",
        "permissions": "Permissions",
        "sso": "SSO",
        "ingress": "Ingress",
        "imports": "Imports",
        "transformations": "Transformations",
        "octo": "Octo",
        "rules": "Rules",
        "visualizer": "Visualizer",
        "action": "Action",
        "adaOrder": "AdaOrder",
        "adaPogs": "AdaPOGs",
        "backofficeLegacy": "Backoffice (legacy)",
        "developer": "Developer",
        "exec": "Exec",
        "fieldTool": "Field Tool",
        "impact": "Impact",
        "messages": "Messages",
        "productRecognition": "Product recognition",
        "psi": "PSI",
        "review": "Review",
        "setup": "Setup",
        "devices": "Devices",
        "firmware": "Firmware",
        "blackhat": "Blackhat",
        "deployment": "Deployment",
        "factoryQa": "Factory QA",
        "fieldDeployment": "Field deployment",
        "fieldIms": "Field IMS",
        "fieldMaintenanceVisit": "Field maintenance visits",
        "fieldQa": "Field QA",
        "fieldSetup": "Field setup",
        "fieldStatus": "Field status",
        "fieldStore": "Field store commands",
        "fieldTasks": "Field tasks",
        "ims": "IMS shipments",
        "imsAddresses": "IMS addresses",
        "labelPrint": "Label printing",
        "opsTasks": "Ops tasks",
        "otaVersions": "OTA versions",
        "payment": "Payment",
        "payroll": "Payroll",
        "storeAccess": "Store access"
      }
    }
  },
  "groups": {
    "title": "Groups",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "description": "Description",
        "noOfUsers": "Users",
        "createdAt": "Created"
      },
      "addGroupButton": "Create Group",
      "searchPlaceholder": "Search groups..."
    },
    "dialog": {
      "createTitle": "Create Group"
    },
    "form": {
      "name": "Name",
      "description": "Description",
      "validation": {
        "required": "Required",
        "nameFormat": "Use lowercase letters, digits and underscores (max 32 characters)"
      }
    },
    "notifications": {
      "created": "Group \"{{name}}\" created",
      "updated": "Group \"{{name}}\" updated"
    }
  },
  "permissions": {
    "title": "Permissions"
  },
  "visualizer": {
    "title": "Visualizer"
  },
  "sso": {
    "title": "Single Sign-On",
    "pageTitle": "Single Sign-On Realms"
  },
  "vendors": {
    "title": "Vendors",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "apiKey": "API Key",
        "chain": "Chain",
        "status": "Status",
        "createdAt": "Created"
      },
      "searchPlaceholder": "Search vendors...",
      "filter": {
        "chain": "Chain",
        "searchChains": "Search chains…",
        "noChains": "No chains found"
      },
      "actions": {
        "activate": "Activate",
        "deactivate": "Deactivate"
      },
      "addVendorButton": "Create Vendor"
    },
    "notifications": {
      "activated": "Vendor \"{{name}}\" activated",
      "deactivated": "Vendor \"{{name}}\" deactivated",
      "created": "Vendor \"{{name}}\" created"
    },
    "dialog": {
      "deactivateTitle": "Deactivate Vendor",
      "activateTitle": "Activate Vendor",
      "deactivatePrompt": "Are you sure you want to deactivate",
      "activatePrompt": "Are you sure you want to activate",
      "deactivateWarning": "This vendor will immediately lose access to the ingress and export APIs.",
      "deactivateConfirm": "Deactivate",
      "activateConfirm": "Activate",
      "createTitle": "Create Vendor",
      "createdTitle": "Vendor Created",
      "createdWarning": "Copy the private key now — it will not be shown again.",
      "apiKeyLabel": "API Key",
      "privateKeyLabel": "Private Key"
    },
    "form": {
      "name": "Name",
      "chain": "Chain",
      "selectChain": "Select chain",
      "searchChains": "Search chains…",
      "noChains": "No chains found",
      "validation": {
        "required": "Required",
        "nameMaxLength": "Name must be at most 32 characters",
        "nameFormat": "Only lowercase letters, digits and underscores are allowed"
      }
    },
    "usage": {
      "kind": {
        "ingress": "Ingress",
        "export": "Export"
      },
      "columns": {
        "id": "ID",
        "usage": "Usage",
        "type": "Type",
        "store": "Store",
        "chain": "Chain",
        "source": "Source",
        "status": "Status",
        "createdAt": "Created"
      },
      "storeDeleted": "{{id}} (deleted)"
    }
  },
  "rules": {
    "title": "Rules"
  },
  "ingressImports": {
    "title": "Imports"
  },
  "transformations": {
    "title": "Transformations",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "key": "Key",
        "target": "Target",
        "outputTypes": "Output Types",
        "status": "Status",
        "createdAt": "Created"
      },
      "addButton": "Create Transformation",
      "searchPlaceholder": "Search transformations...",
      "actions": {
        "activate": "Activate",
        "deactivate": "Deactivate",
        "viewSessions": "View Sessions"
      },
      "filter": {
        "chain": "Chain",
        "store": "Store"
      }
    },
    "dialog": {
      "createTitle": "Create Transformation",
      "comingSoon": "Coming soon",
      "deactivateTitle": "Deactivate Transformation",
      "activateTitle": "Activate Transformation",
      "deactivatePrompt": "Are you sure you want to deactivate",
      "activatePrompt": "Are you sure you want to activate",
      "deactivateWarning": "Before deactivating transformation, check if it's not used in SFTP/Email importers.",
      "deactivateConfirm": "Deactivate",
      "activateConfirm": "Activate"
    },
    "detail": {
      "title": "Transformation Details",
      "comingSoon": "Coming soon",
      "tabs": {
        "info": "Info",
        "files": "Files",
        "sql": "SQL",
        "activityLog": "Activity"
      },
      "fields": {
        "id": "ID",
        "shortName": "Short Name",
        "description": "Description",
        "target": "Target",
        "outputTypes": "Output Types",
        "perStore": "Per Store",
        "onlyLiveStores": "Only Live Stores",
        "status": "Status",
        "createdAt": "Created",
        "inputFiles": "Input Files",
        "yes": "Yes",
        "no": "No",
        "updatedAt": "Updated",
        "sqlContent": "SQL Query",
        "sqlContentLabel": "SQL content",
        "copyToClipboard": "Copy",
        "noFiles": "No input files defined",
        "noSql": "No SQL content",
        "fileType": "File Type",
        "exampleFileName": "Example File",
        "variesPerStore": "Varies Per Store",
        "regex": "Regex",
        "forcedFix": "Forced Fix",
        "loadExtras": "Load Extras",
        "validateColumns": "Validate Columns",
        "checkDate": "Check Date",
        "targetName": "Target Name"
      }
    }
  },
  "chains": {
    "title": "Chains",
    "tabs": {
      "info": "Info",
      "edit": "Edit",
      "settings": "Settings",
      "regions": "Regions",
      "stores": "Stores",
      "cutOffTimes": "Cut-Off Times",
      "imports": "Imports",
      "activityLog": "Activity"
    },
    "list": {
      "columns": {
        "id": "ID",
        "legibleName": "Name",
        "chainName": "Key",
        "timezone": "Timezone",
        "numberOfStores": "Stores",
        "status": "Status"
      },
      "actions": {
        "duplicate": "Duplicate",
        "compareSettings": "Compare Settings"
      },
      "searchPlaceholder": "Search chains...",
      "filter": {},
      "addChainButton": "Create Chain"
    },
    "form": {
      "legibleName": "Display Name",
      "chainName": "Chain Name",
      "defaultTimeZone": "Default Time Zone",
      "copySettings": "Copy settings from existing chain",
      "selectTimezone": "Select timezone",
      "searchTimezones": "Search timezones…",
      "noTimezones": "No timezones found",
      "selectCopyFrom": "Select chain to copy from",
      "searchCopyFrom": "Search chains…",
      "noCopyFrom": "No chains found",
      "chainNameExists": "A chain with this name already exists",
      "legibleNameExists": "A chain with this display name already exists"
    },
    "dialog": {
      "createTitle": "Create Chain",
      "duplicateTitle": "Duplicate Chain"
    },
    "notifications": {
      "created": "Chain \"{{name}}\" created",
      "updated": "Chain \"{{name}}\" updated",
      "createFailed": "Failed to create chain"
    },
    "storeCount_one": "{{count}} store",
    "storeCount_other": "{{count}} stores",
    "regions": {
      "columns": {
        "regionName": "Region Name",
        "storesCount": "Stores"
      }
    },
    "info": {
      "fields": {
        "displayName": "Display Name",
        "chainName": "Chain Name",
        "defaultTimeZone": "Default Time Zone",
        "status": "Status",
        "stores": "Stores"
      },
      "storeSummary": "{{active}} active of {{total}}"
    },
    "compare": {
      "title": "Compare Settings",
      "onlyDiffs": "Differences",
      "noDifferences": "No differences found",
      "dialog": {
        "title": "Compare Chain Settings",
        "description": "Select two chains to compare their settings.",
        "sourceLabel": "Source chain",
        "targetLabel": "Compare with",
        "pickChain": "Pick a chain…",
        "compare": "Compare"
      }
    }
  },
  "stores": {
    "title": "Stores",
    "missingDataWarning": "Store is missing data, please provide the values and save.",
    "list": {
      "columns": {
        "id": "ID",
        "legibleName": "Name",
        "chain": "Chain",
        "storeName": "Key",
        "storeCode": "Store Code",
        "regionName": "Region",
        "timezone": "Timezone",
        "openTime": "Opens",
        "closeTime": "Closes",
        "goLiveDate": "Go-Live Date",
        "status": "Status"
      },
      "actions": {
        "duplicate": "Duplicate",
        "deactivate": "Deactivate",
        "activate": "Activate",
        "archive": "Archive",
        "compareSettings": "Compare Settings",
        "tools": "Tools",
        "triggerShc": "Fetch SHC from API"
      },
      "searchPlaceholder": "Search stores...",
      "filter": {
        "chain": "Chain",
        "region": "Region",
        "searchRegions": "Search regions…",
        "noRegions": "No regions found"
      },
      "addStoreButton": "Create Store"
    },
    "dialog": {
      "createTitle": "Create Store",
      "duplicateTitle": "Duplicate Store",
      "deactivateTitle": "Deactivate Store",
      "activateTitle": "Activate Store",
      "deactivatePrompt": "Are you sure you want to deactivate",
      "deactivateConsequencesIntro": "This will:",
      "deactivateConsequence1": "Disable all cameras belonging to the store",
      "deactivateConsequence2": "Prevent users assigned to the store from logging in",
      "activatePrompt": "Are you sure you want to activate",
      "deactivateConfirm": "Deactivate",
      "activateConfirm": "Activate"
    },
    "form": {
      "legibleName": "Display Name",
      "storeName": "Store Name",
      "storeCode": "Store Code",
      "chainName": "Chain",
      "timeZone": "Time Zone",
      "copySettings": "Copy settings from existing store",
      "selectChain": "Select chain",
      "searchChains": "Search chains…",
      "noChains": "No chains found",
      "selectTimezone": "Select timezone",
      "searchTimezones": "Search timezones…",
      "noTimezones": "No timezones found",
      "selectCopyFrom": "Select store to copy from",
      "searchCopyFrom": "Search stores…",
      "noCopyFrom": "No stores found",
      "notSet": "Not set",
      "goLiveDate": "Go-Live Date",
      "cannotChangeAfterCreation": "Cannot be changed after creation",
      "address": "Address",
      "city": "City",
      "state": "State",
      "zipCode": "ZIP Code",
      "country": "Country",
      "region": "Region",
      "selectCountry": "Select country",
      "searchCountries": "Search countries…",
      "noCountries": "No countries found",
      "selectRegion": "Select region",
      "searchRegions": "Search regions…",
      "noRegions": "No regions found"
    },
    "cameraCount_one": "{{count}} device",
    "cameraCount_other": "{{count}} devices",
    "compare": {
      "title": "Compare Settings",
      "onlyDiffs": "Differences",
      "noDifferences": "No differences found",
      "dialog": {
        "title": "Compare Store Settings",
        "description": "Select two stores to compare their settings.",
        "sourceLabel": "Source store",
        "targetLabel": "Compare with",
        "pickStore": "Pick a store…",
        "compare": "Compare"
      }
    },
    "notifications": {
      "created": "Store \"{{name}}\" created",
      "updated": "Store \"{{name}}\" updated"
    },
    "info": {
      "wipBanner": "Work in progress — coming soon",
      "fields": {
        "displayName": "Display Name",
        "storeName": "Store Name",
        "storeCode": "Store Code",
        "chain": "Chain",
        "goLiveDate": "Go-Live Date",
        "status": "Status",
        "address": "Address",
        "city": "City",
        "state": "State",
        "zipCode": "ZIP Code",
        "country": "Country",
        "region": "Region",
        "timeZone": "Time Zone",
        "openTime": "Open Time",
        "closeTime": "Close Time",
        "deviceType": "Device Type",
        "cameras": "Devices",
        "cameraOnTime": "Cameras On",
        "cameraOffTime": "Cameras Off"
      },
      "cameraCountSummary": "{{active}} active of {{total}}",
      "storeDetails": {
        "title": "Store Details"
      },
      "address": {
        "title": "Address"
      },
      "hours": {
        "title": "Hours"
      },
      "impactSettings": {
        "title": "Impact Settings"
      },
      "matchSettings": {
        "title": "Match Settings"
      },
      "scheduleSettings": {
        "title": "Schedule Settings"
      }
    },
    "operations": {
      "fields": {
        "storeHours": "Store hours",
        "cameraHours": "Camera hours",
        "priorityLogic": "Priority Logic",
        "sortingLogic": "Sorting Logic",
        "minWorkable": "Minimum Workable",
        "isPromoOnTop": "Promo on top",
        "isAssociatesCanSort": "Associates can sort",
        "isShowDsdItems": "Show DSD items",
        "isShowNonWorkable": "Show non-workable",
        "isHidePog": "Hide POG",
        "isDisableIngress": "Disable ingress",
        "isExcludeFromQueue": "Exclude from queue",
        "isDiscrepDisableIngress": "Disable discrep ingress",
        "cooldownHours": "Cooldown Hours"
      },
      "selectPriorityLogic": "Select priority logic",
      "selectSortingLogic": "Select sorting logic",
      "searchOption": "Search…",
      "noOption": "No options found",
      "notifications": {
        "updated": "Operations settings updated for \"{{name}}\""
      }
    },
    "hardware": {
      "fields": {
        "ssid": "SSID",
        "password": "Password",
        "username": "Username",
        "authMode": "Auth Mode",
        "timeout": "Timeout (ms)",
        "otaVersion": "ESP32 OTA version",
        "sc25OtaVersion": "SC25 OTA version",
        "sc25OtaComponentVersion": "SC25 OTA version ({{cpuType}} / {{firmwareType}})",
        "forceUnfreezeDevices": "Force assign to all devices",
        "overrideChainVersion": "Override chain version",
        "remoteUrl": "Image Receiver URL",
        "jpgQuality": "JPEG Quality",
        "deploymentInterval": "Deployment Interval",
        "streamingTime": "Streaming Time (s)",
        "autoWhiteBalance": "Auto White Balance"
      },
      "firmwareSection": "Firmware",
      "networkSection": "Network",
      "selectAuthMode": "Select auth mode",
      "selectOtaVersion": "Select ESP32 OTA version",
      "selectSc25OtaVersion": "Select SC25 OTA version",
      "forceUnfreezeDevicesHint": "Single device OTA configs will be overridden",
      "notifications": {
        "updated": "Hardware settings updated for \"{{name}}\""
      }
    },
    "map": {
      "title": "Store Map",
      "noMap": "No map uploaded for this store.",
      "uploadButton": "Upload Map",
      "uploadSuccess": "Map uploaded successfully",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "resetView": "Reset view"
    },
    "schedule": {
      "everyday": "Everyday schedule",
      "exceptions": "Exceptions",
      "noExceptions": "No exceptions. The everyday schedule runs every day.",
      "legend": "Legend:",
      "copyEveryday": "Copy everyday",
      "addPinHint": "Click the track to add a capture time",
      "algorithmTimed": "{{count}} images/day · algorithm-timed",
      "capturesPerDay": "{{count}} images/day",
      "fields": {
        "images": "Images",
        "awakeTime": "Awake"
      },
      "strategies": {
        "every_hour": "Every hour",
        "no_of_images": "N images/day",
        "static": "Time windows",
        "strict": "Exact times"
      },
      "labels": {
        "model": "Model",
        "off": "Off",
        "human": "Human",
        "qr": "QR"
      },
      "popover": {
        "window": "Window {{range}}",
        "slotAt": "Capture at {{time}}",
        "remove": "Remove"
      },
      "exception": {
        "addTitle": "Add exception",
        "editTitle": "Edit exception",
        "subtitle": "Choose when this schedule applies instead of the everyday one.",
        "scheduleHeading": "Exception schedule",
        "name": "Name",
        "tickets": "Tickets",
        "rule": "Rule",
        "ruleInvalid": "Invalid rule syntax",
        "variables": "Available variables"
      },
      "notifications": {
        "updated": "Schedule updated for \"{{name}}\""
      },
      "mixedLabel": "Mixed",
      "add": "Add"
    },
    "cutOffTimes": {
      "searchPlaceholder": "Search cut-off times...",
      "noCutOffTimes": "No cut-off times",
      "everyDay": "Every day",
      "default": "Default",
      "localTimeNote": "Times are in the store's local time",
      "useCases": {
        "reporting": "Reporting",
        "impact": "Impact"
      },
      "scopes": {
        "store": "store",
        "chain": "chain"
      },
      "filter": {
        "useCase": "Use case",
        "scope": "Scope"
      },
      "columns": {
        "id": "ID",
        "cutOffTime": "Time",
        "useCase": "Use case",
        "dayOfWeek": "Days",
        "department": "Department",
        "taskType": "Task type",
        "isDefault": "Default",
        "scope": "Set on"
      },
      "days": {
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat",
        "sun": "Sun"
      },
      "addButton": "Add Cut-Off Time",
      "form": {
        "createTitle": "Add Cut-Off Time",
        "editTitle": "Edit Cut-Off Time",
        "chainWideWarning": "This applies to every store in the chain, unless a store overrides it with its own cut-off time.",
        "cutOffTime": "Time",
        "useCase": "Use case",
        "days": "Days",
        "department": "Department",
        "taskType": "Task type",
        "isDefault": "Default",
        "isDefaultHint": "Use as the primary cut-off for this condition",
        "everyDayHint": "none selected — every day",
        "notRequired": "not required",
        "validation": {
          "cutOffTimeRequired": "Pick a cut-off time",
          "cutOffTimeStep": "Cut-off times go in 15-minute steps"
        },
        "duplicate": "A cut-off time with these settings already exists for this store"
      },
      "notifications": {
        "created": "Cut-off time added",
        "createFailed": "Could not add the cut-off time",
        "updated": "Cut-off time updated",
        "updateFailed": "Could not update the cut-off time",
        "deleted": "Cut-off time deleted",
        "deleteFailed": "Could not delete the cut-off time"
      },
      "actions": {
        "edit": "Edit",
        "delete": "Delete",
        "noChainPermissionHint": "You don't have permission to change chain-wide cut-off times",
        "noStorePermissionHint": "You don't have permission to change this store's cut-off times"
      },
      "deleteDialog": {
        "title": "Delete cut-off time?",
        "description": "The {{useCase}} cut-off at {{time}} will be removed. This cannot be undone.",
        "chainWideWarning": "This is a chain-wide cut-off. Removing it changes behaviour for every store in the chain that doesn't set its own.",
        "confirm": "Delete"
      }
    },
    "bulkCreate": {
      "title": "Bulk create stores",
      "sheet": "Sheet",
      "uploadPrompt": "Upload a spreadsheet",
      "uploadHint": "XLSX, XLS or CSV — the first row must be column headers",
      "selectColumn": "Select column",
      "noColumn": "— None —",
      "unnamedColumn": "Column {{index}}",
      "rowCount": "{{count}} rows",
      "previewNote": "Showing {{shown}} of {{total}} rows",
      "validSummary": "{{valid}} valid · {{invalid}} with issues",
      "rowColumn": "Row",
      "errorColumn": "Error",
      "creating": "Creating stores…",
      "createdCount": "{{count}} created",
      "failedCount": "{{count}} failed",
      "createButton": "Create {{count}} stores",
      "downloadFailures": "Download failures",
      "back": "Back",
      "errors": {
        "noSheets": "No sheets found in the file",
        "parseFailed": "Could not read the file",
        "createFailed": "Create failed",
        "missing": "{{field}} is required",
        "unknownChain": "Chain ‘{{chain}}’ not found",
        "dupCode": "Duplicate store code ‘{{code}}’",
        "requiredUnmapped": "Map all required (*) fields to continue",
        "badTime": "{{field}} ‘{{raw}}’ is not a valid time",
        "timeOrder": "Opening time must not be after closing time",
        "hoursFailed": "Could not read the store back to apply hours",
        "hoursUnavailable": "Store hours skipped — the store’s operations data was unavailable",
        "patchFailed": "Follow-up update failed",
        "cameraTimeOrder": "Camera on time must not be after camera off time"
      },
      "mode": {
        "column": "Column",
        "constant": "Value",
        "computed": "Computed"
      },
      "computedHint": "Derived: chain_storeCode",
      "valuePlaceholder": "Enter a value",
      "next": "Next",
      "selectedSummary": "{{selected}} of {{total}} selected",
      "existsSummary": "{{count}} already exist",
      "invalidSummary": "{{count}} invalid",
      "selectAll": "Select all",
      "searchColumns": "Search columns…",
      "noColumns": "No columns found",
      "appendCode": "+ (store code)",
      "selectSheet": "Select sheet",
      "searchSheets": "Search sheets…",
      "noSheetsFound": "No sheets found",
      "includeAddress": "Include address",
      "active": "Active",
      "includeHours": "Include store & camera hours",
      "patchFailedCount": "{{count}} follow-up updates failed",
      "patchIssue": "Store created, follow-up update failed: {{error}}",
      "skippedCount": "{{count}} skipped",
      "skippedExists": "Skipped — store already exists"
    },
    "tools": {
      "menuLabel": "Tools",
      "bulkCreate": "Bulk create stores"
    }
  },
  "storeHealth": {
    "refreshAll": "Refresh all",
    "refreshPanel": "Refresh {{panel}}",
    "lastChecked": "Last checked {{time}}",
    "retry": "Retry",
    "panelError": "Could not load this panel.",
    "noReferenceStore": "This chain has no reference store configured, so there is nothing to compare against.",
    "searchPlaceholder": "Search table and setting…",
    "clearSearch": "Clear search",
    "onlyDifferences": "Differences only ({{count}})",
    "noRows": "Nothing to show.",
    "status": {
      "pass": "Pass",
      "warn": "Warn",
      "fail": "Fail",
      "info": "Info",
      "skip": "Skipped"
    },
    "origin": {
      "canon": "Canon",
      "reference": "Reference",
      "store-only": "Store-only"
    },
    "columns": {
      "check": "Check",
      "status": "Status",
      "value": "Value",
      "threshold": "Threshold",
      "setting": "Setting",
      "expected": "Expected",
      "storeValue": "Store value"
    },
    "panels": {
      "identity": {
        "title": "Identity & store setup",
        "description": "The store's physical and identity setup."
      },
      "cameras": {
        "title": "Cameras & templates",
        "description": "Camera streaming, template drift and outstanding scan-in work."
      },
      "planograms": {
        "title": "Planograms & catalog",
        "description": "Planogram coverage and catalog quality."
      },
      "imports": {
        "title": "Imports",
        "description": "Inbound customer feeds and shelf-capacity freshness."
      },
      "settingsDiff": {
        "title": "Settings & config diff",
        "description": "Compared against <store/>. Diagnostic — not a pass/fail verdict.",
        "descriptionGeneric": "Compared against the chain reference store. Diagnostic — not a pass/fail verdict."
      }
    }
  },
  "dataTable": {
    "noResults": "No results.",
    "showing": "Showing {{from}}-{{to}} of {{total}}",
    "noResultsCount": "No results",
    "rows": "{{count}} rows",
    "export": "Export",
    "resetColumns": "Reset to default",
    "allTimesIn": "All times are in <tz/>",
    "presets": {
      "label": "Presets",
      "empty": "No saved presets",
      "save": "Save current filters…",
      "saveTitle": "Save filter preset",
      "saveDescription": "Saves the current filters, search and sort under a name you can re-apply in one click. Page size is not saved.",
      "nameLabel": "Preset name",
      "namePlaceholder": "e.g. UK stores not yet live",
      "overwrite": "Overwrite",
      "overwriteHint": "A preset with this name already exists — saving replaces it.",
      "delete": "Delete preset \"{{name}}\"",
      "clear": "Clear preset",
      "saved": "Preset \"{{name}}\" saved",
      "deleted": "Preset \"{{name}}\" deleted"
    }
  },
  "common": {
    "loading": "Loading…",
    "useValue": "Use \"{{value}}\"",
    "noResults": "No results found",
    "copiedToClipboard": "Copied to clipboard:",
    "active": "Active",
    "workInProgress": "Work in progress…",
    "createdAt": "Created",
    "updatedAt": "Updated",
    "clear": "Clear",
    "fileTypeNotAccepted": "Only {{types}} files are accepted"
  },
  "passkeys": {
    "title": "Passkeys",
    "description": "Passkeys let you sign in with your fingerprint, face, or device PIN instead of a password.",
    "empty": "No passkeys yet. Add one to sign in faster next time.",
    "namePlaceholder": "Passkey name (e.g. MacBook Touch ID)",
    "add": "Add passkey",
    "adding": "Setting up…",
    "registered": "Passkey added",
    "revoke": "Revoke",
    "revoked": "Passkey revoked",
    "added": "Added {{date}}",
    "lastUsed": "last used {{date}}",
    "neverUsed": "never used",
    "deviceType": {
      "multi_device": "Synced",
      "single_device": "This device"
    },
    "error": "Something went wrong. Please try again.",
    "revokeDialog": {
      "title": "Revoke Passkey",
      "prompt": "Are you sure you want to revoke",
      "warning": "This passkey can no longer be used to sign in. This action cannot be undone.",
      "confirm": "Revoke"
    }
  },
  "settings": {
    "title": "Settings",
    "columns": {
      "name": "Name",
      "key": "Key",
      "setting": "Setting"
    },
    "info": {
      "title": "Setting Information",
      "showMore": "Show more",
      "showLess": "Show less",
      "fields": {
        "key": "Key",
        "name": "Name",
        "description": "Description",
        "noDescription": "No description",
        "group": "Group",
        "type": "Type",
        "defaultValue": "Default Value",
        "chainOverrides": "Chain Overrides",
        "storeOverrides": "Store Overrides"
      }
    },
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "key": "Key",
        "groupName": "Group",
        "fieldType": "Type",
        "defaultValue": "Default",
        "chainOverrides": "Chain Overrides",
        "storeOverrides": "Store Overrides",
        "value": "Value",
        "source": "Source",
        "status": "Status"
      },
      "filter": {
        "overridesOnly": "Overrides",
        "group": "Group",
        "searchGroups": "Search groups…",
        "noGroups": "No groups found",
        "chainOverrides": "Chain overrides",
        "storeOverrides": "Store overrides"
      },
      "searchPlaceholder": "Search settings...",
      "actions": {
        "edit": "Edit",
        "restoreDefault": "Restore Default"
      },
      "editDialog": {
        "title": "Edit Setting",
        "nameLabel": "Name",
        "keyLabel": "Key",
        "defaultValueLabel": "Default Value",
        "valueLabel": "Value",
        "selectPlaceholder": "Select a value",
        "selectSearchPlaceholder": "Search values…",
        "noValues": "No values",
        "invalidNumber": "Must be a valid number",
        "cancel": "Cancel",
        "save": "Save"
      },
      "restoreDialog": {
        "title": "Restore Default",
        "description": "Are you sure you want to restore \"{{name}}\" to its default value?",
        "cancel": "Cancel",
        "confirm": "Restore"
      },
      "toast": {
        "updated": "Setting \"{{name}}\" updated",
        "updateError": "Failed to update setting",
        "restored": "Setting \"{{name}}\" restored to default",
        "restoreError": "Failed to restore setting"
      },
      "jsonPreview": {
        "description": "This preview is formatted for readability. The original value is stored minified.",
        "copy": "Copy"
      }
    },
    "chains": {
      "columns": {
        "id": "ID",
        "name": "Chain",
        "value": "Value",
        "status": "Status"
      },
      "searchPlaceholder": "Search chains..."
    },
    "stores": {
      "columns": {
        "id": "ID",
        "store": "Store",
        "chain": "Chain",
        "value": "Value",
        "status": "Status"
      },
      "searchPlaceholder": "Search stores..."
    },
    "status": {
      "override": "override",
      "default": "default",
      "store": "store",
      "chain": "chain"
    }
  },
  "imports": {
    "importData": "Import Data",
    "importCsv": "Import CSV",
    "searchPlaceholder": "Search imports…",
    "columns": {
      "id": "ID",
      "publicId": "Public ID",
      "timestamp": "Created",
      "type": "Type",
      "createdBy": "Uploaded By",
      "store": "Store",
      "source": "Source",
      "processingTime": "Processing Time",
      "status": "Status",
      "validationTime": "Validation Time",
      "queueingTime": "Queueing Time",
      "itemsFound": "Items Found",
      "productsFound": "Products Found",
      "productsCreated": "Products Created",
      "productsUpdated": "Products Updated",
      "productsZeroed": "Products Zeroed",
      "storeCode": "Store Code",
      "items": "Items",
      "createdAt": "Created"
    },
    "actions": {
      "retrigger": "Re-trigger",
      "downloadJson": "Download JSON file",
      "downloadCsv": "Download CSV file",
      "copyRawJson": "Copy raw JSON path",
      "copyRawCsv": "Copy raw CSV path",
      "downloadError": "Could not generate download link"
    },
    "retrigger": {
      "title": "Re-trigger import",
      "prompt": "Run this import again. Use this to recover from a failure.",
      "confirm": "Re-trigger",
      "success": "Import #{{id}} queued for re-trigger",
      "errorTitle": "Could not re-trigger import",
      "errors": {
        "missingContent": "Import #{{id}} has no prepared JSON file and cannot be re-triggered.",
        "notFound": "Import #{{id}} was not found."
      },
      "includeSubsequent": {
        "label": "Also re-trigger subsequent imports",
        "hint": "Re-run later imports of the same type for this store, in order."
      }
    },
    "csv": {
      "title": "Import CSV",
      "typeLabel": "Import type",
      "typePlaceholder": "Select import type…",
      "types": {
        "metadata": "Metadata",
        "boh": "Balance on Hand",
        "sales": "Sales",
        "pricing": "Pricing"
      },
      "fileLabel": "CSV file",
      "fileDropTitle": "Drop CSV file or click to upload",
      "overrideStoreCode": "Override store code",
      "uploadingPercent": "Uploading… {{percent}}%",
      "processing": "Converting rows…",
      "upload": "Upload",
      "success": "Import #{{id}} created with {{count}} items",
      "errorTitle": "Could not import this file",
      "moreErrors": "…and {{count}} more"
    },
    "wizard": {
      "title": "Import Data",
      "submitButton": "Submit Import",
      "submittedSuccess": "Import submitted successfully",
      "inactiveTransformation": {
        "title": "This transformation is deactivated",
        "hint": "You can still submit an import, but consistency and reliability of imported data is not guaranteed."
      },
      "steps": {
        "scope": "Scope",
        "transformation": "Transformation",
        "upload": "Upload",
        "validate": "Validate",
        "preview": "Preview"
      },
      "scope": {
        "selectChain": "Select a chain…",
        "searchChains": "Search chains…",
        "noChains": "No chains found",
        "selectStore": "Select a store (optional)…",
        "searchStores": "Search stores…",
        "noStores": "No stores found"
      },
      "transformation": {
        "select": "Select a transformation…",
        "search": "Search transformations…",
        "empty": "No transformations found",
        "filesToPrepare": "Files you need to prepare"
      },
      "upload": {
        "startingSession": "Starting import session…",
        "uploadingPercent": "Uploading… {{percent}}%",
        "processing": "Processing…",
        "dropFile": "Drop file or click to upload ({{fileType}})"
      },
      "validate": {
        "validating": "Validating files…",
        "errorsTitle": "Validation Errors Found",
        "errorsCount": "{{errors}} errors in {{files}} files",
        "errorColumn": "(column: {{column}})",
        "errorRow": "at row {{location}}"
      },
      "preview": {
        "submitting": "Submitting import…",
        "preparing": "Preparing import requests…",
        "preparingProgress": "Preparing store {{current}} of {{total}}…",
        "submittingProgress": "Creating import request {{current}} of {{total}}…",
        "filesProcessed": "Files processed",
        "validFiles": "Valid files",
        "totalRecords": "Total records",
        "storesAffected": "Stores affected",
        "estDuration": "Est. duration",
        "storeCodes": "Processed store codes",
        "importRequests": "Import requests",
        "itemsCount": "{{count}} items"
      }
    }
  },
  "tabs": {
    "info": "Info",
    "health": "Health",
    "edit": "Edit",
    "permissions": "Permissions",
    "boPermissions": "BO permissions",
    "users": "Users",
    "chains": "Chains",
    "stores": "Stores",
    "map": "Map",
    "settings": "Settings",
    "operations": "Operations",
    "schedule": "Schedule",
    "cutOffTimes": "Cut-Off Times",
    "devices": "Devices",
    "hardware": "Hardware",
    "imports": "Imports",
    "security": "Security",
    "activityLog": "Activity",
    "usage": "Usage"
  },
  "profile": {
    "title": "My Profile",
    "edit": {
      "wip": "Editing your profile isn't available yet."
    },
    "security": {
      "sso": {
        "title": "Single sign-on account",
        "description": "You sign in through your organization's identity provider (SSO). Your password, passkeys, and two-factor authentication are managed there and can't be set up here."
      },
      "password": {
        "title": "Password",
        "description": "Change the password you use to sign in.",
        "current": "Current password",
        "new": "New password",
        "confirm": "Confirm new password",
        "submit": "Change password",
        "submitting": "Changing…",
        "success": "Password changed",
        "required": "This field is required",
        "tooShort": "Use at least 8 characters",
        "mismatch": "New passwords don't match",
        "invalid": "Your current password is incorrect",
        "error": "Couldn't change your password. Please try again."
      },
      "mfa": {
        "title": "Two-factor authentication",
        "description": "Add an extra layer of security with an authenticator app.",
        "statusLabel": "Authenticator app",
        "enabledStatus": "Enabled",
        "setup": "Set up two-factor",
        "disable": "Disable",
        "setupTitle": "Set up two-factor authentication",
        "setupDescription": "Scan the QR code with your authenticator app, then enter the 6-digit code to confirm.",
        "qrAlt": "Two-factor QR code",
        "secretLabel": "Or enter this setup key manually",
        "codeLabel": "Verification code",
        "enable": "Enable",
        "enabled": "Two-factor authentication enabled",
        "invalidCode": "That code didn't match. Please try again.",
        "generateError": "Couldn't start setup. Please try again.",
        "disableTitle": "Disable two-factor authentication",
        "disableConfirm": "Your account will no longer require a verification code at sign-in. Are you sure?",
        "disabled": "Two-factor authentication disabled",
        "disableError": "Couldn't disable two-factor. Please try again."
      }
    },
    "settings": {
      "appearance": {
        "title": "Appearance",
        "description": "Theme, language and date format for this device."
      },
      "theme": {
        "label": "Theme"
      },
      "accent": {
        "label": "Accent color",
        "options": {
          "green": "Green",
          "red": "Red",
          "blue": "Blue"
        }
      },
      "language": {
        "label": "Language",
        "hint": "Applies to labels and messages only — it does not change how dates are formatted."
      },
      "dateFormat": {
        "label": "Date format",
        "hint": "Applies to every date in the app. “System” follows your operating system’s regional settings.",
        "options": {
          "system": "System",
          "dmy": "Day first",
          "mdy": "Month first",
          "iso": "Year first (ISO)"
        }
      },
      "tables": {
        "title": "Tables",
        "description": "Defaults for list and table views."
      },
      "itemsPerPage": {
        "label": "Items per page",
        "hint": "Applied to each table the next time you open it."
      },
      "integrations": {
        "title": "Integrations",
        "description": "Connect your accounts to Focal."
      },
      "slack": {
        "label": "Slack username",
        "placeholder": "@your.handle",
        "hint": "Saved to your account.",
        "save": "Save",
        "saved": "Slack username saved",
        "saveError": "Couldn't save your Slack username. Please try again."
      },
      "advanced": {
        "title": "Advanced",
        "description": "Diagnostics and reset options."
      },
      "diagnostics": {
        "title": "Diagnostics",
        "description": "Developer and QA tools for this device."
      },
      "httpErrorToasts": {
        "label": "Show HTTP error toasts",
        "hint": "Show a toast with request and response details whenever an API call fails (422, 5xx or network error). Useful for QA and debugging."
      },
      "reset": {
        "title": "Reset preferences",
        "description": "Clear all device-local settings back to their defaults.",
        "button": "Reset local preferences",
        "toast": "Preferences reset",
        "dialog": {
          "title": "Reset local preferences?",
          "description": "This clears theme, language, table layouts and other device-local settings, then reloads the app. Your account and sign-in are not affected.",
          "cancel": "Cancel",
          "confirm": "Reset"
        }
      }
    }
  },
  "activity": {
    "searchPlaceholder": "Search activity...",
    "empty": "No activity found",
    "wipBanner": "Work in progress — data is mocked",
    "filter": {
      "timeRange": "Time Range",
      "onlyChain": "Only chain"
    }
  },
  "buttons": {
    "cancel": "Cancel",
    "create": "Create",
    "save": "Save",
    "discard": "Discard",
    "stayOnPage": "Stay on page",
    "discardAndLeave": "Discard & leave",
    "schedule": "Schedule",
    "submitForApproval": "Submit for Approval",
    "back": "Back",
    "next": "Next",
    "validate": "Validate",
    "edit": "Edit",
    "done": "Done",
    "close": "Close"
  },
  "unsavedChanges": {
    "title": "Unsaved Changes",
    "description": "You have unsaved changes. Are you sure you want to leave? Your changes will be lost."
  },
  "notifications": {
    "title": "Notifications",
    "empty": "No notifications",
    "wipBanner": "Work in progress — data is mocked",
    "markAllRead": "Mark all as read",
    "markRead": "Mark read",
    "dismiss": "Dismiss",
    "actions": {
      "review": "Review",
      "approve": "Approve"
    },
    "mock": {
      "importFailed": {
        "title": "Import failed for Lidl DE #4012",
        "description": "Product catalog import failed due to missing required columns. Manual review needed."
      },
      "settingApproval": {
        "title": "Setting change requires approval",
        "description": "\"camera_resolution\" was changed on Aldi Süd — Berlin Mitte. Awaiting your approval."
      },
      "importComplete": {
        "title": "Import completed successfully",
        "description": "Planogram import for Carrefour FR completed — 847 items processed."
      },
      "storeOffline": {
        "title": "Store cameras offline",
        "description": "3 cameras at Tesco UK — Manchester Central have been offline for over 2 hours."
      },
      "userCreated": {
        "title": "New user created",
        "description": "User \"m.schmidt@lidl.com\" was created and assigned to Lidl DE."
      },
      "settingUpdated": {
        "title": "Setting updated",
        "description": "\"detection_threshold\" default value changed from 0.7 to 0.75."
      }
    }
  },
  "header": {
    "commands": "Commands..."
  },
  "approvals": {
    "title": "Approvals",
    "tabs": {
      "pending": "Pending",
      "resolved": "Resolved"
    },
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "executed": "Executed",
      "failed": "Failed"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject"
    },
    "actionTypes": {
      "create-chain": "Create Chain"
    },
    "scheduleForLater": "Schedule for later",
    "requestedExecutionTime": "Requested execution time (after approval)",
    "scheduledFor": "Scheduled for {{time}}",
    "scheduledForFooter": "Scheduled for: {{time}}",
    "requestedBy": "Requested by {{name}}",
    "resolvedBy": "{{action}} by {{name}}",
    "rejectionReason": "Reason (optional)",
    "rejectDescription": "Provide an optional reason for rejecting this action.",
    "submitDialog": {
      "title": "Submit for Approval",
      "titleWithAction": "Submit \"{{action}}\" for Approval",
      "description": "Review the details below. An admin will need to approve this action before it's executed.",
      "scheduleHint": "Leave empty to execute immediately after approval.",
      "messagePlaceholder": "Message to approver (optional)"
    },
    "clearSchedule": "Clear",
    "noActions": "No pending actions",
    "wipBanner": "Work in progress — data is mocked",
    "noResolvedActions": "No resolved actions",
    "notifications": {
      "scheduled": "\"{{name}}\" has been scheduled",
      "submittedForApproval": "\"{{name}}\" submitted for approval"
    }
  },
  "commandPalette": {
    "placeholder": "Type a command or search...",
    "empty": "No results found.",
    "pages": "Pages",
    "settings": "Settings",
    "commands": "Commands",
    "profile": "Profile",
    "myProfile": "My Profile",
    "debug": "Debug",
    "logout": "Logout",
    "back": "Back",
    "footer": {
      "navigate": "Navigate",
      "select": "Select",
      "goBack": "Go back",
      "close": "Close"
    },
    "createChain": "Create Chain",
    "createStore": "Create Store",
    "createUser": "Create User",
    "createVendor": "Create Vendor",
    "createTransformation": "Create Transformation",
    "importData": "Import Data",
    "compareChainSettings": "Compare Chain Settings",
    "compareStoreSettings": "Compare Store Settings",
    "refreshView": "Refresh Current View",
    "featureFlags": "Feature Flags",
    "telemetry": "API Telemetry",
    "showcase": "Component Showcase",
    "flagOn": "on",
    "flagOff": "off",
    "telemetryClearAll": "Clear all",
    "telemetryEmpty": "No requests recorded yet.",
    "theme": {
      "title": "Change Theme",
      "placeholder": "Select theme...",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    },
    "accent": {
      "title": "Change Accent Color",
      "placeholder": "Select accent color..."
    },
    "language": {
      "title": "Change Language",
      "placeholder": "Select language..."
    },
    "createOctoRule": "Create Octo Rule",
    "createFirmwareVersion": "Create Firmware Version"
  },
  "octoRules": {
    "title": "Octo Rules",
    "unnamed": "Rule #{{id}}",
    "unnamedShort": "Unnamed",
    "scopeGlobal": "Global",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "scope": "Scope",
        "stage": "Stage",
        "outcome": "Outcome",
        "priority": "Priority",
        "createdAt": "Created",
        "status": "Status"
      },
      "searchPlaceholder": "Search rules...",
      "filter": {
        "chain": "Chain",
        "store": "Store",
        "stage": "Stage",
        "searchStages": "Search stages…",
        "noStages": "No stages found"
      },
      "actions": {
        "activate": "Activate",
        "deactivate": "Deactivate"
      },
      "addRuleButton": "Create Rule"
    },
    "stage": {
      "creation": "Creation",
      "visibility": "Visibility",
      "workability": "Workability"
    },
    "outcome": {
      "allow": "Allow",
      "deny": "Deny"
    },
    "fields": {
      "name": "Name",
      "description": "Description",
      "scope": "Scope",
      "stage": "Stage",
      "outcome": "Outcome",
      "priority": "Priority",
      "predicate": "Rule",
      "tickets": "Tickets",
      "startDate": "Start date",
      "endDate": "End date",
      "status": "Active",
      "createdAt": "Created",
      "updatedAt": "Updated"
    },
    "detail": {
      "tabs": {
        "info": "Info",
        "edit": "Edit",
        "activity": "Activity"
      }
    },
    "edit": {
      "updated": "Rule \"{{name}}\" updated",
      "predicateInvalid": "Invalid CEL expression",
      "predicateUnknownProperty": "Unrecognised property",
      "variables": "Variables",
      "allowedValues": "Allowed values",
      "predicateInvalidValue": "Invalid value",
      "predicateDecimalExpected": "Decimal expected",
      "predicateRuntimeTypeError": "Will fail when evaluated",
      "predicateObjectNotValue": "Object, not a value",
      "availableFields": "Available fields",
      "fields": "{{variable}} fields"
    },
    "dialog": {
      "activateTitle": "Activate rule",
      "deactivateTitle": "Deactivate rule",
      "activatePrompt": "Are you sure you want to activate",
      "deactivatePrompt": "Are you sure you want to deactivate",
      "activateConfirm": "Activate",
      "deactivateConfirm": "Deactivate",
      "deactivateWarning": "This rule will stop being applied by Octo while inactive.",
      "createTitle": "Create Rule",
      "created": "Rule \"{{name}}\" created"
    },
    "form": {
      "chain": "Chain",
      "store": "Store",
      "scopeLabel": "Scope",
      "selectChain": "Select chain…",
      "selectStore": "Select store…"
    },
    "tools": {
      "menuLabel": "Tools",
      "evaluate": "Evaluate rules"
    },
    "evaluate": {
      "title": "Evaluate rules",
      "contextTitle": "Evaluation context",
      "contextHint": "Pick a task type to run the chain. Add a product and a time to evaluate against them.",
      "taskType": "Task type",
      "selectTaskType": "Select task type…",
      "searchTaskTypes": "Search task types…",
      "noTaskTypes": "No task types found",
      "evaluatedAt": "Current date & time",
      "product": {
        "upc": "UPC",
        "itemNumber": "Item number",
        "upcPlaceholder": "Product UPC",
        "itemNumberPlaceholder": "Item number"
      },
      "timezoneHint": "Times are read as local time in the store ({{timezone}}). Leave empty to use now.",
      "timezoneHintGeneric": "Times are read as local time in the store. Leave empty to use now.",
      "pickStore": "Pick a store to see the rules it would walk through.",
      "running": "Evaluating…",
      "failed": "Evaluation failed",
      "noRules": "No rules apply to this store and stage.",
      "runButton": "Evaluate",
      "stoppedHere": "Evaluation stopped here",
      "priorityLabel": "priority {{priority}}",
      "noPredicate": "No predicate — always applies",
      "outOfDateRange": "Outside its start/end window, but still evaluated — the engine ignores those dates.",
      "outcomeTitle": "Result",
      "outcomeNone": "Undetermined",
      "scope": {
        "global": "Global",
        "chain": "Chain",
        "store": "Store"
      },
      "evaluation": {
        "matched": "Matched",
        "notMatched": "No match",
        "fallback": "Fallback",
        "skippedInactive": "Inactive",
        "notReached": "Not reached",
        "error": "Error",
        "notEvaluated": "Not evaluated"
      },
      "reason": {
        "ruleMatched": "Decided by \"{{rule}}\" — the first rule whose predicate matched.",
        "fallbackRule": "Decided by \"{{rule}}\" — a rule with no predicate, so it always applies.",
        "implicitFallback": "No rule matched. The engine falls back to deny.",
        "compileError": "The rules for this stage could not be compiled, so none of them ran.",
        "evaluationError": "Evaluation failed part-way through, so no decision was reached.",
        "noRules": "No active rules for this store and stage — the engine does not intervene.",
        "notEvaluated": "Not evaluated yet. Pick a task type and press Evaluate."
      },
      "effect": {
        "creation": {
          "allow": "The task would be created.",
          "deny": "The task would be suppressed and never created."
        },
        "visibility": {
          "allow": "The task would be visible in the store.",
          "deny": "The task would be hidden from the store."
        },
        "workability": {
          "allow": "The task would be workable.",
          "deny": "The task would not be workable."
        }
      },
      "debug": {
        "compiledRule": "Compiled rule chain",
        "boundContext": "Bound context",
        "empty": "Empty"
      }
    }
  },
  "devices": {
    "title": "Devices",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Name",
        "store": "Store",
        "chain": "Chain",
        "createdAt": "Created",
        "lastImage": "Last Image",
        "lastStatus": "Last Status",
        "status": "Status"
      },
      "searchPlaceholder": "Search devices...",
      "filter": {
        "chain": "Chain",
        "store": "Store"
      }
    }
  },
  "firmware": {
    "title": "Firmware",
    "list": {
      "columns": {
        "id": "ID",
        "version": "Version",
        "versionNum": "Build",
        "deviceType": "Device",
        "cpuType": "CPU",
        "firmwareType": "Firmware",
        "production": "Production",
        "createdAt": "Created",
        "status": "Status"
      },
      "searchPlaceholder": "Search versions...",
      "filter": {
        "deviceType": "Device type",
        "searchDeviceTypes": "Search device types…",
        "noDeviceTypes": "No device types found",
        "cpuType": "CPU type",
        "searchCpuTypes": "Search CPU types…",
        "noCpuTypes": "No CPU types found",
        "production": "Production"
      },
      "addButton": "Create Version"
    },
    "fields": {
      "versionStr": "Version",
      "versionNum": "Build number",
      "deviceType": "Device type",
      "cpuType": "CPU type",
      "fileUri": "File URI",
      "md5": "MD5",
      "changeLog": "Change log",
      "createdAt": "Created",
      "updatedAt": "Updated",
      "file": "Firmware file"
    },
    "production": {
      "ready": "production",
      "draft": "draft"
    },
    "actions": {
      "activate": "Activate",
      "deactivate": "Deactivate",
      "markProduction": "Mark production-ready",
      "unmarkProduction": "Unmark production-ready"
    },
    "dialog": {
      "activateTitle": "Activate version",
      "deactivateTitle": "Deactivate version",
      "activatePrompt": "Are you sure you want to activate",
      "deactivatePrompt": "Are you sure you want to deactivate",
      "deactivateWarning": "Devices will no longer receive this firmware while it is inactive.",
      "activateConfirm": "Activate",
      "deactivateConfirm": "Deactivate",
      "markProductionTitle": "Mark production-ready",
      "unmarkProductionTitle": "Unmark production-ready",
      "markProductionPrompt": "Mark as production-ready",
      "unmarkProductionPrompt": "Remove the production-ready flag from",
      "markProductionConfirm": "Mark production-ready",
      "unmarkProductionConfirm": "Unmark",
      "createTitle": "Create Firmware Version",
      "created": "Version \"{{name}}\" created",
      "productionLabel": "Production-ready",
      "fileHint": "Upload the firmware binary ({{ext}})",
      "fileDropTitle": "Drop firmware file or click to browse",
      "cpuPlaceholder": "Select CPU type",
      "fileHintArchive": "Upload the firmware archive ({{ext}})",
      "createFailed": "Could not create the firmware version. Please try again.",
      "versionExists": "This version already exists for the selected device type",
      "fileRequired": "Select a firmware file to upload",
      "buildNumberExists": "This build number already exists for the selected device type"
    },
    "detail": {
      "tabs": {
        "info": "Info",
        "assignments": "Assignments"
      }
    },
    "assignments": {
      "empty": "No chains, stores or devices are assigned to this version.",
      "frozen": "Frozen",
      "columns": {
        "scope": "Scope",
        "target": "Target",
        "frozen": "Frozen",
        "assignedAt": "Assigned",
        "id": "ID"
      },
      "scope": {
        "device": "Device",
        "store": "Store",
        "chain": "Chain"
      },
      "searchPlaceholder": "Search assignments...",
      "searchScopes": "Search scopes…",
      "noScopes": "No scopes found"
    }
  },
  "updateAvailable": {
    "message": "A new version is available.",
    "reload": "Reload"
  }
}
